line{stroke:#0000;stroke-width:var(--h3-interactive-border-line-width)}
/*# sourceMappingURL=interactive-border-line.component.css.map */
